import { render } from "./single-card-wide.vue?vue&type=template&id=50c27fa8"
import script from "./single-card-wide.vue?vue&type=script&lang=js"
export * from "./single-card-wide.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__